import * as React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";
import Ann from "../img/annWatkins.jpg";
import Sarah from "../img/sarahPantalone.jpeg";
// import Kristin from "../img/kristinAndrulonis.jpg";
// import Julie from "../img/julieAlmeida.jpeg";
import Randy from "../img/randy.jpg";

function About() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">About Us</h2>

          <p className="pageLead">
            Our mission: to provide healing and improve the quality of life on
            the planet, one person at a time.
          </p>

          <h4 className="subTitle">Our Approach</h4>
          <p>
            Our massage therapy is quite unlike any other type in that it
            corrects the underlying problems associated with chronic pain. We
            work with you to discover the cause and correct it, allowing you
            relief from pain that you have not been able to achieve with other
            forms of medicine and therapies. Our clients usually start
            experiencing relief after the first session with marked results by
            the third and may require maintenance sessions in order to
            maintain relief. In cases where relief does not require
            maintenance, many of our clients still return to achieve enhanced
            relaxation as well as physical and emotional well being.
          </p>

          <h4 className="subTitle">Chronic Pain Breakthrough</h4>
          <p>
            <em>Our massage therapy is unlike any massage you've ever had.</em>{" "}
            We work together with a special technique to create muscle balance
            and tissue health, relieving and correcting the underlying problems
            associated with most chronic pain. Our clients usually begin to get
            relief right away and by the third session it&rsquo;s clear what
            the solution to your problem is.
          </p>
          <Link to="/therapies">
            <Button>Therapies We Offer ››</Button>
          </Link>

          {/* Ann */}
          <h3 className="sectionTitle">Owner</h3>
          <div className="profile">
            <img src={Ann} className="profilePhoto" alt="Ann Watkins" />
            <div className="profileBody">
              <h4 className="profileName">Ann Watkins, MA</h4>
              <p className="profileCred">
                Licensed Massage Therapist #000393
              </p>
              <p>
                Honors in Psychology, MA in Dance Movement Therapy, Licensed
                Massage Therapist since 1988, published in Massage Magazine.
                Trained in Lymphatic Drainage; Energy Work: shiatsu,
                acupressure, polarity; NeuroMuscular Reprogramming /
                NeuroKinetic Therapy; originator of (Neuro) Reactive Triads™
                Bodywork, a breakthrough in chronic pain relief (DVD).
              </p>
              <div className="missionQuote">
                <strong>Mission statement:</strong> My mission is to inspire
                self-connection and self-responsibility; to promote
                self-healing and well-being; to enhance the quality of life on
                earth one person at a time.
              </div>
            </div>
          </div>

          {/* Staff */}
          <h3 className="sectionTitle">Staff</h3>
          <p>
            <a
              href="https://newharmonymassage.weebly.com/staff.html"
              target="_blank"
              rel="noreferrer"
            >
              Our Licensed Massage Therapists ››
            </a>
          </p>

          <div className="profile">
            <img src={Sarah} className="profilePhoto" alt="Sarah Pantalone" />
            <div className="profileBody">
              <h4 className="profileName">Sarah Pantalone, MA</h4>
              <p className="profileCred">Licensed Massage Therapist</p>
              <p>
                Sarah is a licensed massage therapist who offers individually
                tailored sessions for each of her clients in both CranioSacral
                therapy and postural corrective work incorporating various
                osteopathic modalities, as well as Neurolymphatic Reactive
                Triads™ Bodywork for chronic pain breakthrough. She is
                passionate about working with all of her clients to help them
                on their journey of healing, as well as women on their journey
                of pregnancy and restoration of balance and healing postpartum.
              </p>
              <p>
                Sarah is a graduate of Connecticut Center for Massage Therapy
                where she received foundational training and has since
                continued her studies in osteopathic modalities enabling her to
                interface and work directly with the central nervous system,
                the peripheral nerves and the organs of the abdomen. She is now
                receiving training from Ann Watkins at New Harmony Therapeutic
                Massage and Somatic Bodywork in her original Neurolymphatic
                Reactive Triads™ Bodywork. This specialized training has
                enhanced Sarah&rsquo;s abilities when working with clients who
                have chronic pain for which traditional treatments and
                therapies have not worked and who have experienced trauma in
                any of a multitude of forms. She also works with women
                contemplating pregnancy, who are pregnant or who have ever been
                pregnant.
              </p>
              <p>
                <em>
                  Sarah is taking some time away to support her daughter's
                  schooling. Please take advantage of Kristin's availability
                  and call for an appointment.
                </em>
              </p>
            </div>
          </div>

          {/* In Memoriam */}
          <p className="eyebrow">In Memoriam</p>
          <div className="profile" style={{ marginTop: "0.5rem" }}>
            <img
              src={Randy}
              className="profilePhoto small"
              alt="Randy Shepherd"
            />
            <div className="profileBody">
              <h4 className="profileName">Randy Shepherd, CBW</h4>
              <p className="profileCred">
                Licensed Massage Therapist #002742
              </p>
              <p>
                A graduate of Alive and Well! Institute of Conscious BodyWork,
                in Corte Madera, Ca. in 1999. Completed their &ldquo;Conscious
                BodyWorker&rdquo; program with over 600 hours of instruction
                and hands on training in both structural and energetic
                approaches. He moved from the San Francisco bay area in July of
                1999, and worked as a bodyworker since that time.
              </p>
              <div className="missionQuote">
                <strong>Mission statement:</strong> I am a professional
                bodyworker dedicated to providing therapeutic, life enhancing
                bodywork. By being sensitive to the needs of others and by
                using various techniques and skills, I assist them in becoming
                the best they choose to be.
              </div>
              <p>
                Personal: I touch lives in a positive uplifting and healing
                manner. This I do with honesty, integrity and love, encouraging
                the best to shine through.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default About;
